import React from 'react';
import { connect } from 'react-redux';
import { provideLocalizationService, registerForIntl, registerForLocalization } from '@progress/kendo-react-intl';
import { Dialog, DialogActionsBar } from '@progress/kendo-react-dialogs';
import { Button } from '@progress/kendo-react-buttons';
import { Grid } from '../../shared/components';
import { Text } from '../../../ui';
import { loadStudyProgramCaseList, openStudyProgramCaseConfirmDialog, closeStudyProgramCaseConfirmDialog, removeStudyProgramCaseConfirmDialog } from '../actions/study-program-case-list-actions';
import { withRouter } from '../../../components/withRouter';

class StudyProgramCaseList extends React.Component {
  constructor(props) {
    super(props);
    this.handleEditClick = this.handleEditClick.bind(this);
    this.handleRemoveClick = this.handleRemoveClick.bind(this);
    this.handleConfirmDialogClose = this.handleConfirmDialogClose.bind(this);
    this.handleRemoveConfirm = this.handleRemoveConfirm.bind(this);
  }

  async componentDidMount() {
    await this.props.loadStudyProgramCaseList({
      studyProgramId: this.props.studyProgramId
    });
  }

  render() {
    const { studyProgramCases, loading, isConfirmDialogVisible, canWrite } = this.props;
    const localizationService = provideLocalizationService(this);
    return (
      <>
        <Grid
          loading={loading}
          data={studyProgramCases}
          isPageable={false}
          columns={[
            {
              field: 'name',
              className: 'align-left',
              headerClassName: 'align-left',
              title: localizationService.toLanguageString('studyProgram.name')
            }
          ]}
          actions={
            canWrite &&
          [
            { icon: 'edit', onClick: this.handleEditClick },
            { icon: 'delete', onClick: this.handleRemoveClick }
          ]}
        />
        {isConfirmDialogVisible &&
          <Dialog title={localizationService.toLanguageString('custom.confirm')} onClose={this.handleConfirmDialogClose}>
            <Text>{`${localizationService.toLanguageString('studyProgram.studyProgramCaseDialogMessage')} ${this.props.selectedStudyProgramCaseAssignedCount}`}</Text>
            <DialogActionsBar>
              <Button themeColor={'primary'} onClick={this.handleRemoveConfirm}>{localizationService.toLanguageString('buttons.delete')}</Button>
              <Button onClick={this.handleConfirmDialogClose}>{localizationService.toLanguageString('buttons.cancel')}</Button>
            </DialogActionsBar>
          </Dialog>
        }
      </>
    );
  }

  handleEditClick(row) {
    this.props.navigate(`/study_programs/${this.props.studyProgramId}/cases/${row.dataItem.id}`);
  }

  handleRemoveClick(e) {
    this.props.openStudyProgramCaseConfirmDialog(e.dataItem);
  }

  handleConfirmDialogClose() {
    this.props.closeStudyProgramCaseConfirmDialog();
  }

  handleRemoveConfirm() {
    this.props.removeStudyProgramCaseConfirmDialog({
      studyProgramId: this.props.studyProgramId
    });
  }
}

const mapStateToProps = (state) => ({
  studyProgramCases: state.studyProgramCaseList.studyProgramCases,
  loading: state.studyProgramCaseList.loading,
  isConfirmDialogVisible: state.studyProgramCaseList.isConfirmDialogVisible,
  selectedStudyProgramCaseAssignedCount: state.studyProgramCaseList.selectedStudyProgramCaseAssignedCount,
  canWrite: state.studyProgramCaseList.canWrite
});

const mapDispatchToProps = (dispatch) => ({
  loadStudyProgramCaseList: (payload) => dispatch(loadStudyProgramCaseList(payload)),
  openStudyProgramCaseConfirmDialog: (payload) => dispatch(openStudyProgramCaseConfirmDialog(payload)),
  closeStudyProgramCaseConfirmDialog: (payload) => dispatch(closeStudyProgramCaseConfirmDialog(payload)),
  removeStudyProgramCaseConfirmDialog: (payload) => dispatch(removeStudyProgramCaseConfirmDialog(payload))
});

registerForIntl(StudyProgramCaseList);
registerForLocalization(StudyProgramCaseList);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(StudyProgramCaseList));